module.exports = ".dialog-footnote {\n    font-size: 13px;\n    font-style: italic;\n}\n\n.footer-list {\n   padding-left: 0px;\n   padding-right: 0px;\n   padding-top: 0px;\n   padding-bottom:0px;\n   margin-top:0px;\n   margin-right:0px;\n   margin-left:0px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/faktur-pajak-masukan/adjust-periode-pajak/adjust-periode-pajak.component.css
// module id = ./src/app/faktur-pajak-masukan/adjust-periode-pajak/adjust-periode-pajak.component.css
// module chunks = main